import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69017029"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form_link" }

import {useStore} from 'vuex'
import axios from "axios";
import {useRouter} from "vue-router"
import {reactive, ref, getCurrentInstance} from 'vue';
import type {FormInstance, FormRules} from 'element-plus'
import {ElMessage} from 'element-plus'
// 获取自定义接口

export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props, { expose: __expose }) {

// 导入实例
const publicApiUrl = getCurrentInstance().appContext.config.globalProperties.$publicPath.publicApiUrl;

// 获取apiUrl
const store: any = useStore();
// dialog控制
const entryVisible = ref(false);
const forgetVisible = ref(false);
const codeVisible = ref(false);
const data: any = reactive({
  logged: store.state.logged,
});
// 获取参数
const router: any = useRouter();
// 表单内容
const entryForm: any = ref<FormInstance>()
const forgetForm: any = ref<FormInstance>()
const codeForm: any = ref<FormInstance>()

const entryFormData = reactive({
	Account: '',
	password: '',
})
const forgetFormData = reactive({
	phone: '',
	password: '',
	checkPassword: '',
	code: '',
	disabled: false,
})
const codeFormData = reactive({
	verificationCode: '',
	code: '',
})
// 自定义验证
const checkAgainPassword = (rule: any, value: any, callback: any) => {
	if (value != forgetFormData.password) {
		callback(new Error());
	} else {
		callback();
	}
}
// 验证规则
const entryRules: any = reactive<FormRules>({
	Account: [
		{required: true, message: '请输入邮箱/手机号', trigger: 'blur'},
	],
	password: [
		{required: true, message: '请输入密码', trigger: 'blur'},
		{pattern: /[0-9a-zA-Z]{8,20}/, message: "密码必须为字母加数字,长度为8-20位", trigger: "blur"},
	],
})
const forgetRules: any = reactive<FormRules>({
	phone: [
		{required: true, message: '请输入手机号', trigger: 'blur'},
		{max: 11, message: '手机号长度必须最大为11位', trigger: 'blur'},
	],
	password: [
		{required: true, message: '请输入密码', trigger: 'blur'},
		{pattern: /[0-9a-zA-Z]{8,20}/, message: "密码必须为字母加数字,长度为8-20位", trigger: "blur"},
	],
	checkPassword: [
		{required: true, message: '请再次输入新登录密码', trigger: 'blur'},
		{validator: checkAgainPassword, message: '两次输入的新登录密码必须相同',}
	],
	code: [
		{required: true, message: '请输入验证码', trigger: 'blur'},
		{min: 4, max: 6, message: '验证码长度为4-6位', trigger: 'blur'},
	],
})
const codeFormRules: any = reactive<FormRules>({
	code: [
		{required: true, message: '请输入验证码', trigger: 'blur'},
	],
})

// 登录提交
const entrySubmit = async (formEl: FormInstance | undefined) => {
	try {
		await entryForm.value.validate((valid: any, fields: any) => {
			if (valid) {
				axios.post(publicApiUrl.login, {
					Account: entryFormData.Account,
					loginpwd: entryFormData.password,
				}).then(function (res) {
							if (res.status == 200) {
								if (res.data.Code) {
									ElMessage({
										message: res.data.Detail,
										type: 'error',
										duration: 1000,
									})
								} else {
                  //ElMessage.success('登录成功!');
									data.logged = true;
									store.state.logged = true;
									entryVisible.value = false;
									store.state.userData = res.data;
									sessionStorage.setItem('userData', JSON.stringify(res.data));
                  setTimeout(()=>{
                    history.go(0);
                  },300)
								}
							} else {
								console.error(res);
							}
						},
						function (res) {
							console.error(res);
						}
				);
			} else {
				console.log('提交失败!',)
			}
		})
	} catch (error) {
		console.log('错误B');
	}
}
// 绑定手机号获取后台验证码
const getVerificationCode = (value: any) => {
	axios.get(publicApiUrl.SendVerificationCode + '?mobile=' + forgetFormData.phone).then(function (res) {
				if (res.status == 200) {
					if (res.data.Code) {
						ElMessage.error(res.data.Detail);
					} else {
						codeFormData.verificationCode = res.data;
						codeVisible.value = true;
					}
				} else {
					console.error(res);
				}
			},
			function (res) {
				console.error(res);
			}
	);
}
// 绑定手机号获取短信验证码
const getForgetCode = (value: any) => {
	if (codeFormData.verificationCode == codeFormData.code) {
		axios.get(publicApiUrl.SendMobileVerificationCode + '?mobile=' + forgetFormData.phone).then(function (res) {
					if (res.status == 200) {
						if (res.data != 'sucess') {
							ElMessage.error(res.data.Msg);
						} else {
							ElMessage.success('短信验证码已发送!');
							codeFormData.code = '';
							codeVisible.value = false;
							forgetFormData.disabled = true;
							setTimeout(() => {
								forgetFormData.disabled = false;
							}, 1000 * 60 * 5);
						}
					} else {
						console.error(res);
					}
				},
				function (res) {
					console.error(res);
				}
		);
	} else {
		ElMessage.error('有必填项未填写或验证未通过!');
	}
	
}
// 忘记密码提交
const forgetSubmit = async (formEl: FormInstance | undefined) => {
	try {
		await forgetForm.value.validate((valid: any, fields: any) => {
			if (valid) {
				forgetFormData.disabled = false;
				axios.post(publicApiUrl.RetrievePassword, {
					Mobile: forgetFormData.phone,
					NewPassword: forgetFormData.password,
					VerificationCode: forgetFormData.code,
				}).then(function (res) {
							if (res.status == 200) {
								if (res.data.Code) {
									ElMessage({
										message: res.data.Detail,
										type: 'error',
										duration: 1000,
									})
								} else {
									ElMessage.success('密码重置成功!');
									forgetVisible.value = false;
									forgetFormData.phone = '';
									forgetFormData.password = '';
									forgetFormData.checkPassword = '';
									forgetFormData.code = '';
								}
							} else {
								console.error(res);
							}
						},
						function (res) {
							console.error(res);
						}
				);
			} else {
				console.log('提交失败!',)
			}
		})
	} catch (error) {
		console.log('错误B');
	}
}
__expose({entryVisible})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      width: "400px",
      modelValue: entryVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((entryVisible).value = $event)),
      title: "登录"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "entryForm",
          ref_key: "entryForm",
          ref: entryForm,
          model: entryFormData,
          rules: entryRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "Account" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: entryFormData.Account,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((entryFormData.Account) = $event)),
                  autocomplete: "off",
                  placeholder: "邮箱/手机号:"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  "show-password": "",
                  modelValue: entryFormData.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((entryFormData.password) = $event)),
                  placeholder: "请输入密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              style: {"width":"100%"},
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (entrySubmit(entryFormData)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("登录")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => {forgetVisible.value = true;})
              }, "忘记密码")
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "400px",
      modelValue: forgetVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((forgetVisible).value = $event)),
      title: "忘记密码"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "forgetForm",
          ref: forgetForm,
          model: forgetFormData,
          rules: forgetRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "phone" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: forgetFormData.phone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((forgetFormData.phone) = $event)),
                  autocomplete: "off",
                  placeholder: "请输入手机号,最大为11位"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  "show-password": "",
                  modelValue: forgetFormData.password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((forgetFormData.password) = $event)),
                  placeholder: "请输入新密码,字母或数字,长度为8-20位"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "checkPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  "show-password": "",
                  modelValue: forgetFormData.checkPassword,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((forgetFormData.checkPassword) = $event)),
                  placeholder: "请确认新密码,字母或数字,长度为8-20位"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "code" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"calc(100% - 13px - 92px)","margin-right":"13px"},
                  oninput: "value=value.replace(/[^\\d-]/g,'');",
                  modelValue: forgetFormData.code,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((forgetFormData.code) = $event)),
                  placeholder: "请输入验证码,长度为4-6位"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  disabled: forgetFormData.disabled,
                  type: "primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (getVerificationCode()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 获取验证码 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              style: {"width":"100%"},
              type: "primary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (forgetSubmit(forgetFormData)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("找回密码")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "400px",
      modelValue: codeVisible.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((codeVisible).value = $event)),
      title: "请输入验证码"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          style: {"text-align":"center","font-size":"28px","font-weight":"bold","color":"#009fff","margin-bottom":"22px","cursor":"pointer"},
          onClick: _cache[12] || (_cache[12] = ($event: any) => (getVerificationCode()))
        }, _toDisplayString(codeFormData.verificationCode), 1),
        _createVNode(_component_el_form, {
          ref_key: "codeForm",
          ref: codeForm,
          model: codeFormData,
          rules: codeFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "code" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: codeFormData.code,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((codeFormData.code) = $event)),
                  autocomplete: "off",
                  placeholder: "请输入验证码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              style: {"width":"100%"},
              type: "primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (getForgetCode(_ctx.dialogFormRules)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送验证")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})